/**
 * Fire-and-forget activity logger.
 *
 * Emotional safety events MUST be logged but MUST NEVER block the UI or
 * surface errors to the user. We swallow all failures here. If the user is
 * not logged in (no token), the call is silently dropped.
 */
import api from './api';

export const logActivity = (action, metadata = {}) => {
  // Don't block the calling code — return a resolved promise immediately.
  // The HTTP call itself is fire-and-forget.
  try {
    api.post('/activity', { action, metadata }).catch(() => { /* swallow */ });
  } catch {
    // ignore
  }
};
